export default "__VITE_ASSET__ff112151__"